import styled from 'styled-components';
import { black, grey, lightgrey, white } from 'styles/Colors';
import { HotkeyBadgeWrapper } from '../HotkeyBadge/HotkeyBadgeStyles';
import { StyledButton } from './StoreTagButton/StoreTagButtonStyles';
import { NumberStepperWrapper } from 'components/ui/NumberStepper/NumberStepperStyles';

export const ScoreBarWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  max-width: calc(100% - 540px);

  .score {
    font-family: Oswald;
    font-size: 30px;
    font-weight: 500;
    line-height: 30px;
    letter-spacing: 0.68px;
    color: ${black};
    margin-right: 10px;
    margin-left: 10px;
    &.match-score {
      margin-right: 0px;
      margin-left: 0px;
    }
    width: 25px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
  }

  ${NumberStepperWrapper} {
    display: flex;
    align-items: center;
    height: 100%;
  }
`;

export const ScoreBarDivider = styled.span`
  width: 1px;
  height: 32px;
  opacity: 0.25;
  background-color: ${lightgrey};
  margin-right: 26px;
  margin-left: 26px;
`;

export const ScoreLabel = styled.span`
  font-family: Oswald;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: ${grey};
`;

export const ScoreLabelBalls = styled(ScoreLabel)`
  margin-left: 13px;
`;

export const ScoreBarOuter = styled.div`
  position: relative;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.08);
  background-color: ${white};
  display: flex;
  align-items: center;
  padding: 0 40px 0 40px;
`;

export const StoreTagButtonAndHotkeyWrapper = styled.div`
  position: relative;
  margin-left: auto;
  ${HotkeyBadgeWrapper} {
    position: absolute;
    z-index: 1;
    top: 1px;
    left: 101px;
  }
  .inning-direction {
    margin-left: -12px;
    margin-right: 13px;
  }

  ${StyledButton} {
    transition: background-color 0.35s ease, border-color 0.35s ease;
  }
`;
